// Tabs del playground
export const PLAYGROUND_TABS = {
  CREATE: 'create',
  CONFIGURATION: 'configuration',
  KNOWLEDGE: 'knowledge',
  INSTRUCTIONS: 'instructions',
  TOOLS: 'tools',
};

// Mapeo de tabs a rutas
export const TAB_ROUTES = {
  [PLAYGROUND_TABS.CREATE]: 'create',
  [PLAYGROUND_TABS.CONFIGURATION]: 'configuration',
  [PLAYGROUND_TABS.KNOWLEDGE]: 'knowledge',
  [PLAYGROUND_TABS.INSTRUCTIONS]: 'instructions',
  [PLAYGROUND_TABS.TOOLS]: 'tools',
};

// Tipos de agente disponibles
export const AGENT_TYPES = [
  { label: 'AI', value: 'ai' },
];

// Categorías disponibles
export const AGENT_CATEGORIES = [
  { label: 'Sales', value: 'sales' },
  { label: 'Inventory', value: 'inventory' },
  { label: 'Service', value: 'service' },
  { label: 'Operations', value: 'operations' },
  { label: 'Telemetry', value: 'telemetry' },
  { label: 'Analytics', value: 'analytics' },
  { label: 'Finance', value: 'finance' },
  { label: 'HR', value: 'hr' },
];

// Modelos LLM disponibles
export const LLM_MODELS = [
  {
    label: 'Open AI',
    value: 'openai',
    models: [
      { label: 'Chat GPT 4o-mini', value: 'chat-gpt-4o-mini' },
      { label: 'Chat GPT 3.5 Turbo', value: 'chat-gpt-3.5-turbo' },
      { label: 'Chat GPT 4o', value: 'chat-gpt-4o' },
    ],
  },
  {
    label: 'Anthropic',
    value: 'anthropic',
    models: [
      { label: 'Claude 3 Opus', value: 'claude-3-opus' },
    ],
  },
  {
    label: 'Amazon',
    value: 'amazon',
    models: [
      { label: 'Titan Text G1', value: 'titan-text-g1' },
    ],
  },
  {
    label: 'Ollama',
    value: 'ollama',
    models: [
      { label: 'Llama 3.3', value: 'llama3.3' },
      { label: 'Llama 3.2', value: 'llama3.2' },
    ],
  },
  {
    label: 'Mistral AI',
    value: 'mistral',
    models: [
      { label: 'Mistral Medium 3', value: 'mistral-medium-3' },
      { label: 'Magistral Medium', value: 'magistral-medium' },
    ],
  },
];

